<template>
  <div>
    <HeaderBar v-if="showLayoutHeader" />
    <router-view />
    <NavigationBar />
    <loader-item :isLoader='this.$root.fullscreenLoading'></loader-item>
  </div>
</template>
<script>
import HeaderBar from '@/components/HeaderBar.vue'
import LoaderItem from '@/components/loader/loader-item.vue'
import NavigationBar from '@/components/NavigationBar.vue'

export default {
  name: 'MainLayout',
  components: {
    LoaderItem,
    NavigationBar,
    HeaderBar
  },
  computed: {
    showLayoutHeader () {
      return this.$route.path !== '/cargo'
    }
  },
  data () {
    return {
      containerCollapsed: 'toggled',
      tabledata: [],
      user: JSON.parse(localStorage.getItem('user'))

    }
  },
  created () {
  },
  methods: {
    showMenu () {
      this.$root.showMenuDrawerStatus = true
    },
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    }
  }
}

</script>
<style scoped>
.el-header {
  background-color: #ffffff;
  color: #333;
  line-height: 60px;
  padding: 0px;
  min-height: 68px;
}

.el-aside {
  color: #333;
}

.item {
  margin-top: 12px;
  margin-right: 20px;
}
</style>
